export const ERP_READ_RESOURCES = ['orders', 'products', 'automation'] as const
export type ErpReadResource = typeof ERP_READ_RESOURCES[number]
export type ErpReadDetailResource = Exclude<ErpReadResource, 'automation'>

export interface ErpReadStatusOption {
  value: string
  label: string
}

export interface ErpReadResourceCapabilities {
  defaultLimit: number
  limits: readonly number[]
  statuses: readonly ErpReadStatusOption[]
  pagination: boolean
  variationManagerFilter: boolean
}

export const ERP_READ_RESOURCE_CAPABILITIES = {
  orders: {
    defaultLimit: 20,
    limits: [10, 20],
    statuses: [
      { value: 'open', label: 'Open' },
      { value: 'closed', label: 'Closed' },
      { value: 'cancelled', label: 'Cancelled' },
    ],
    pagination: true,
    variationManagerFilter: false,
  },
  products: {
    defaultLimit: 25,
    limits: [10, 25, 50, 100],
    statuses: [
      { value: 'active', label: 'Active' },
      { value: 'discontinued', label: 'Discontinued' },
    ],
    pagination: true,
    variationManagerFilter: true,
  },
  automation: {
    defaultLimit: 25,
    limits: [],
    statuses: [],
    pagination: false,
    variationManagerFilter: false,
  },
} as const satisfies Record<ErpReadResource, ErpReadResourceCapabilities>

export const ERP_READ_SORTS = [
  'updated_at_desc',
  'updated_at_asc',
  'created_at_desc',
  'created_at_asc',
  'title_asc',
  'title_desc',
  'name_asc',
  'name_desc',
] as const
export type ErpReadSort = typeof ERP_READ_SORTS[number]

export interface ErpReadDeskQuery {
  resource: ErpReadResource
  search: string
  statuses: string[]
  sort: ErpReadSort
  limit: number
  variationManagerOnly: boolean
  selectedId: string | null
}

export interface ErpReadDeskRecord {
  id: string
  title?: string | null
  name?: string | null
  created_at?: string | null
  updated_at?: string | null
  _erp_updated_at?: string | null
  [key: string]: unknown
}

export interface ErpReadCollectionResponse<T> {
  data: T[]
  pagination: {
    next_cursor: string | null
    has_more: boolean
    snapshot_at: string
  }
  generated_at: string
}

export interface ErpReadDetailResponse<T> {
  data: T
  generated_at: string
}

export type ErpReadDeskErrorKind = 'unauthorized' | 'forbidden' | 'not_found' | 'rate_limited' | 'upstream' | 'network' | 'unknown'

export interface ErpReadDeskError {
  kind: ErpReadDeskErrorKind
  message: string
  retryAfterSeconds: number | null
}
